<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 21 21"
  >
    <g>
      <path
        :fill="color"
        d="M15.674 7.875l-6.426 6.376a.989.989 0 0 1-1.386.025l-3.402-3.1a1.022 1.022 0 0 1-.075-1.41.997.997 0 0 1 1.41-.051l2.697 2.47 5.746-5.746a1.004 1.004 0 0 1 1.436 0 1.004 1.004 0 0 1 0 1.436zM10.054.467C4.512.467 0 4.977 0 10.52c0 5.544 4.51 10.055 10.055 10.055 5.544 0 10.054-4.51 10.054-10.055C20.11 4.977 15.6.467 10.055.467z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#2CEBA9',
    },
    size: {
      type: Number,
      default: 21,
    },
  },
};
</script>
